import { RetroButton } from '@/components/retro/RetroButton'
import { Package, DollarSign } from 'lucide-react'

export const SellSection = () => {
  return (
    <div className="h-full flex flex-col animate-fade-in p-4">
      <h2 className="text-3xl font-serif font-bold text-gray-900 mb-6 border-b-2 border-gray-400 pb-2">
        Vender Material Moído
      </h2>

      <div className="grid md:grid-cols-2 gap-6 items-center">
        <div className="retro-bevel-outset p-1 bg-white">
          <img
            src="https://img.usecurling.com/p/400/300?q=shredded%20metal%20scrap"
            alt="Material Moído"
            className="w-full h-64 object-cover filter contrast-125 sepia-[.3]"
          />
        </div>

        <div className="space-y-6">
          <div className="retro-bevel-outset p-6 bg-[#eeeeee]">
            <h3 className="text-xl font-bold font-serif mb-2 flex items-center gap-2">
              <Package className="w-6 h-6 text-blue-600" />
              Qualidade Industrial
            </h3>
            <p className="font-serif text-gray-800">
              Oferecemos material processado, limpo e classificado, pronto para
              fundição. Ideal para indústrias que buscam eficiência e redução de
              custos com matéria-prima.
            </p>
          </div>

          <div className="flex flex-col gap-4">
            <RetroButton
              variant="flat-3d"
              className="w-full justify-center text-lg py-3 font-bold"
            >
              Ver Inventário Disponível
            </RetroButton>
            <RetroButton
              variant="flat-3d"
              className="w-full justify-center text-lg py-3 font-bold text-red-700"
            >
              <DollarSign className="w-5 h-5 mr-2" />
              Consultar Tabela de Preços
            </RetroButton>
          </div>
        </div>
      </div>
    </div>
  )
}
